export default __webpack_public_path__ + "static/media/im-title-en.b3ce3379.webp";